export default __webpack_public_path__ + "static/Errorception-1d6936a61535391561f8be65e65630dd.png";